import { darken, lighten, styled } from '@mui/material';

export const ButtonWrapper = styled('div', {
	shouldForwardProp: (prop: string) => !['disabled'].includes(prop),
})<{ disabled: boolean }>(({ disabled }) => {
	const mainColor = disabled ? '#00000042' : '#2090FF';
	return {
		cursor: disabled ? 'default' : 'pointer',
		position: 'absolute',
		textTransform: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '6px',
		color: mainColor,

		width: 'fit-content',
		right: '1px',
		top: '-7px',

		'&:hover': {
			color: lighten(mainColor, disabled ? 0 : 0.25),
		},
		'&:active': {
			color: darken(mainColor, disabled ? 0 : 0.25),
		},
	};
});
